/**
 * Contextual Definitions
 * Membership: The final singular UI object based on assessing the user's subcriptions and teams status
 * Subscriptions: The subscription(s) the user is signed up for (They can have multiple subscriptions)
 * Teams Member/Owner: Users can own or be part of a team which influences their subscription.
 */

import { PRICING } from "data/links";

// constants
const ICON_PRO_TEXT = `unlimited icons. <a href="${PRICING}">Upgrade to Creator Pro for unlimited sets & photos</a>`;
const ICON_PRO_TEXT_INDIVIDUAL = `You have ${ICON_PRO_TEXT}`;
const ICON_PRO_TEXT_TEAM = `Your team has ${ICON_PRO_TEXT}`;

// Subscriptions
const subscriptions = {
    freeMember: {
        title: "Free Member",
        upsellHtml: `<a href="${PRICING}">Get unlimited downloads free with Pro</a>`
    },
    eduMember: {
        title: "Icon Pro EDU Member",
        upsellHtml: ICON_PRO_TEXT_INDIVIDUAL
    },
    iconProMember: {
        title: "Icon Pro Member",
        upsellHtml: ICON_PRO_TEXT_INDIVIDUAL
    },
    creatorProMember: {
        title: "Creator Pro Member",
        upsellHtml: ``
    }
};

// Teams Member/Owner
const teams = {
    iconProTeamMember: {
        title: "Icon Pro Team Member",
        upsellHtml: ``
    },
    iconProTeamOwner: {
        title: "Icon Pro Team Owner",
        upsellHtml: ICON_PRO_TEXT_TEAM
    },
    creatorProTeamMember: {
        title: "Creator Pro Team Member",
        upsellHtml: ``
    },
    creatorProTeamOwner: {
        title: "Creator Pro Team Owner",
        upsellHtml: ``
    }
};

// All Plans
export const plans = {
    ...subscriptions,
    ...teams
};
